<template>
  <div v-if="currentOpenExpos.data !== null">
    <div
      v-if="
        currentOpenExpos.loading !== false && currentOpenExpos.data === null
      "
    >
      <div
        class="alert alert-info d-flex justify-content-between align-items-center"
        role="alert"
      >
        <p class="mb-0">{{ $t("cargando datos...") }}.</p>
      </div>
    </div>
<!-- aviso no hay exposiciones -->
    <div v-if="currentOpenExpos.data.length === 0">
      <div
        class="alert alert-danger d-flex justify-content-between align-items-center"
        role="alert"
      >
        <p class="mb-0">{{ $t("inscripciones_texto_no_expo") }}.</p>
      </div>
    </div>

    <div v-else class="mb-5 pb-5">
      <h4 class="mb-2 mt-2">{{ $t("Nueva inscripción") }}:</h4>
      <p class="mb-4">{{ $t("inscripciones_texto_1") }}:</p>
      <div
        class="alert alert-info d-flex justify-content-between align-items-center"
        role="alert"
      >
        <p class="mb-0">{{ $t("inscripciones_texto_2") }}.</p>
      </div>

      <!-- PESTAÑA - SELECTOR DE EXPOSICIONES DISPONIBLES -->
      <div class="tab-b mb-20" v-if="currentTab === 0">
        <h5>{{ $t("exposiciones disponibles") }}:</h5>
        <ins-opened-comp
          @emitSetCurrentExpo="setCurrentExpoData"
          :seleccionada="datosInscripcion.expoId"
          v-if="currentTab === 0"
        ></ins-opened-comp>
        <div class="clear"></div>

        <div v-if="this.datosInscripcion.expoData !== null">
          <!--CHECK SOCIO Si/No -->
          <div class="row">
            <div class="col-md-6">
              <label class="font-weight-normal">
                {{ $t("socio") }}
                <span class="required">*</span>
              </label>
              <select
                v-model.number="datosInscripcion.socio"
                @change="updatePartner($event)"
              >
                <option value="0">{{ $t("no") }}</option>
                <option value="1">{{ $t("si") }}</option>
              </select>
            </div>

            <!-- input num socio -->
            <div class="col-md-6 pl-0" v-if="showPartnerInput">
              <label class="font-weight-normal">
                {{ $t("numero socio") }}
                <span class="required">*</span>
              </label>
              <input
                class="form-control"
                type="text"
                v-model.number="datosInscripcion.socioNumero"
              />
            </div>
          </div>
          <div class="clear"></div>

          <!-- ACEPTACIÓN DE LAS CONDICIONES -->
          <div class="row">
            <p
              class="mt-30 d-flex justify-content-start align-items-center col-md-12 pl-1"
            >
              <label
                class="d-flex align-items-center woocommerce-form__label woocommerce-form__label-for-checkbox inline"
              >
                <input
                  class="woocommerce-form__input woocommerce-form__input-checkbox ml-4"
                  type="checkbox"
                  v-model.number="datosInscripcion.aceptadasCondiciones"
                  true-value="1"
                  false-value="0"
                />
                <span class="font-weight-normal links-maincolor2">
                  {{ $t("leido") }}
                  <a href="#">{{ $t("politica de privacidad") }}.</a>
                </span>
              </label>
            </p>
          </div>

          <div
            class="alert alert-warning d-flex justify-content-between align-items-center py-3 mt-3"
            role="alert"
          >
            <p class="mb-0">{{ $t("nota_aceptar_politica_privacidad") }}.</p>
          </div>
        </div>
        <!-- div v-if -->
      </div>

      <!-- PESTAÑA - LISTADO DE PERROS PARA INSCRIBIR -->
      <div class="tab-b" v-if="currentTab === 1">
        <Ins-doglist-comp
          :icClass="icClass"
          :expoData="datosInscripcion.expoData"
          :socio="datosInscripcion.socio"
          v-if="currentTab === 1"
          :parentInscripciones="datosInscripcion.inscripciones"
          :datosNormalizados="datosNormalizados"
          @emitInscripciones="setInscripciones"
        />
        <!--         <fab
          :position="position"
          :bg-color="bgColor"
          :actions="fabActions"
          :icon-size="size"
          @cache="alert('cache')"
          @alertMe="alert('hola')"
          main-tooltip="reset"
        ></fab> -->
      </div>

            <!-- PESTAÑA - COMPONENTE PAREJAS -->
      <div class="tab-b mb-5"  v-if="currentTab === 2">
      <!--   {{ compCalcularPerrosInscritos }} -->
        <h6>{{ $t('Inscripción Parejas') }}</h6>
        <ins-pareja
          v-if="compCalcularPerrosInscritos > 1 && currentTab === 2"
          :datos="datosInscripcion"
          :datosNormalizados="datosNormalizados"
          @emitDatosParejas="actualizarParejas"
        ></ins-pareja>
       
      </div>

      <!-- PESTAÑA - COMPONENTE GRUPO CRIA -->
      <div class="tab-b mb-5" v-if="currentTab === 3">
        <h6>Inscripción Grupo Cria</h6>
        <ins-grupo-cria
          v-if="compCalcularPerrosInscritos > 2 && currentTab === 3"
          :datos="datosInscripcion"
          :datosNormalizados="datosNormalizados"
          @emitActualizarDatosCria="actualizarGrupoGria"
        ></ins-grupo-cria>
      
      </div>
<!-- {{currentTab}} {{compCalcularPerrosInscritos}} -->


      <!-- PESTAÑA - OTROS CONCEPTOS -->
      <div
        class="tab-b mb-4"
        v-if="
        currentTab === 4 &&
          datosInscripcion.expoData !== null &&
            datosInscripcion.expoData.expo_otros_conceptos.length > 0
        "
      >
        <div class="row">
          <div class="col-md-12 py-3">
            <h6>{{ $t("otros conceptos facturables") }}</h6>
          </div>
        </div>
        <div
          v-for="c in datosInscripcion.expoData.expo_otros_conceptos"
          :key="c.id"
        >
          <ins-otros-conceptos
            :datos="c"
            :conceptos="datosInscripcion.otrosConceptos"
            @emitAddOtrosC="otrosConceptos"
          ></ins-otros-conceptos>
        </div>
      </div>

      <!-- PESTAÑA - RESUMEN-->
      <div class="tab-b" v-if="currentTab === 5">
        <div v-if="datosInscripcion.expoData !== null && currentTab === 5">
          <ins-final-comp
            :datos="datosInscripcion"
            @emitInsertTabla="testInsertTabla"
            :datosNormalizados="datosNormalizados"
          ></ins-final-comp>
        </div>
      </div>
      <!-- BOTONES -->
      <div
        v-show="
          this.datosInscripcion.expoData !== null &&
            this.datosInscripcion.aceptadasCondiciones == 1
        "
      >
        <div style="overflow:auto;">
          <div style="col-md-12">
            <button
              type="button"
              class="btn btn-secondary float-left"
              id="prevBtn"
              v-on:click="nextTab(-1)"
            >
              {{ $t("paso anterior") }}
            </button>
            <button
              v-if="currentTab < 5"
              type="button"
              class="btn btn-success float-right"
              id="nextBtn"
              v-on:click="nextTab(1)"
            >
              {{ $t("continuar-inscripcion") }}
            </button>
          </div>
        </div>
        <!-- Circles which indicates the steps of the form: -->
        <div style="text-align:center;margin-top:40px;">

          <span class="step" :class="{'active' : currentTab === (n-1)}" v-for="n in 6" :key="n"></span>
        
       <!--    <span class="step"></span>
          <span class="step"></span> -->
        </div>
      </div>
      <button
        v-if="currentTab > 0"
        type="button"
        class="btn btn-danger btn-sm float-right"
        @click="resetear"
      >
        {{ $t("resetear-inscripcion") }}
      </button>
      <!--  <button @click="resetear" v-if="currentTab > 0">reset</button> -->
    </div>
   <!--  {{ currentTab }} -->

    <!--     NumPerros inscritos = {{compCalcularPerrosInscritos}}
    <br /> -->
    <!-- /.MultiStep Form -->
    <!-- alerts are for fun of it -->
    <!--     {{currentTab}} -->
    <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/icon?family=Material+Icons"
    />
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css"
    />
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import InsOpenedComp from "@/components/layouts/inscriptions/Inscriptions-opened-comp";
import InsDoglistComp from "@/components/layouts/inscriptions/Inscriptions-doglist-comp";
import InscriptionsCalcs from "@/_helpers/inscriptions-class";
import InsOtrosConceptos from "@/components/layouts/inscriptions/Inscriptions-otros-conceptos-comp";
import InsFinalComp from "@/components/layouts/inscriptions/Inscriptions-final-component";
import InsGrupoCria from "@/components/layouts/inscriptions/Inscriptions-grupo-cria";
import InsPareja from "@/components/layouts/inscriptions/Inscriptions-pareja";
import fab from "vue-fab";

export default {
  name: "inscriptionnew",
  components: {
    InsOpenedComp,
    InsDoglistComp,
    InsOtrosConceptos,
    InsFinalComp,
    InsGrupoCria,
    fab,
    InsPareja
  },

  data:() =>({   
      /* fab button */
      bgColor: "#C00B3D",
      position: "bottom-right",
      size: "large",
      fabActions: [
        {
          color: "red",
          name: "cache",
          icon: "cached"
        },
        {
          name: "alertMe",
          icon: "add_alert"
        }
      ],
      /* fin fab button */

      currentTab: -1,
      datosInscripcion: {
        aceptadasCondiciones: 0, //aceptacion de las condiciones
        expoId: null, //id de la expo seleccionada
        expoData: null, //datos de la exposición una vez elegida
        gruposCria: null,
        inscripciones: null,
        otrosConceptos: [],
        parejas: null,
        socio: 0,
        socioNumero: null,
        userData: null,
        datosParejas: [],
        datosGrupoCria: []
      },
      icClass: null,
      showPartnerInput: false,     
   
  }),

  methods: {
    ...mapActions("inscription", [
      "getUserOpenExpos",
      "getExpo",
      "getUserInscripcionData"
    ]),
    ...mapMutations("inscription", [
      "actualizarCurrentInscription",
      "resetCurrentIns"
    ]),
    actualizarGrupoGria(datos) {
      console.log("datos grupo cria", datos);
      this.datosInscripcion.datosGrupoCria = datos;
    },
    /* funcion que recibe el emit del comp parejas */
    actualizarParejas(datos) {
      console.log("datos parejas", datos);
      this.datosInscripcion.datosParejas = datos;
    },
    /* TEST INSERT TABLA */
    testInsertTabla() {
      console.log("estoy aqui");
      //const pepe = this.icClass.generaDataInsert()
    },
    /* RESETEAR LA INSC */
    resetear() {
      this.resetCurrentIns(true);
    },
    nextTab(n) {
      
      this.currentTab += n;
      if(this.currentTab < 0) this.currentTab = 0;
    },
    /* AÑADIR OTROS CONCEPTOS A LA INSCRIPCION */
    otrosConceptos(otros) {
      if (this.datosInscripcion.otrosConceptos.length === 0) {
        this.datosInscripcion.otrosConceptos.push(otros);
      } else {
        //comprobamos si existe ya..... y lo eliminamos del filtro
        const otrosC = this.datosInscripcion.otrosConceptos.filter(x => {
          if (x.id !== otros.id) {
            return x;
          }
        });
        this.datosInscripcion.otrosConceptos = otrosC;
        //lo volvemos a agregar actualizado si el numero es mayor que 0
        if (otros.cantidad > 0) {
          this.datosInscripcion.otrosConceptos.push(otros);
        }
      }
    },
    /* RECOGER LAS INSCRIPCIONES DEL COMPONENTE InsDoglistComp  */
    setInscripciones(datos) {
      this.datosInscripcion.inscripciones = datos.inscripciones;
      this.actualizarCurrentInscription(this.datosInscripcion);
    },
    /* Comprobar si es necesario solicitar datos del socio */
    updatePartner(event) {
      //comprobamos si se solicitan los datos del socio
      if (
        this.datosInscripcion.socio === 1 &&
        this.datosInscripcion.expoData.check_partners === 1
      ) {
        this.showPartnerInput = true;
      } else {
        this.showPartnerInput = false;
      }
    },
    /* Selector de la exposición */
    setCurrentExpoData(datos) {
      //no hay expos disponibles mostramos el aviso
      if (datos.id === 0) {
        this.currentTab = -1;
      } else {
        this.datosInscripcion.expoId = datos.id;
        this.datosInscripcion.expoData = datos.data;
        this.currentTab = 0;
      }

      //recogemos los datos de la expo
    },   

    fixStepIndicator: function(n) {
      // This function removes the "active" class of all steps...
      var i,
        x = document.getElementsByClassName("step");
      for (i = 0; i < x.length; i++) {
        x[i].className = x[i].className.replace(" active", "");
      }
      //... and adds the "active" class on the current step:
      x[n].className += " active";
    }
  },

  computed: {
    ...mapState("inscription", [
      "currentOpenExpos",
      "selectedExpo",
      "userInsData"
    ]),
    ...mapGetters("inscription", ["getUserDefaultData"]),
    /* para ver si se pueden incribir grupos de cria */
    compExisteInsGrupoCria() {
      if (this.datosInscripcion.expoData === null) {
        return null;
      }
      const tmp = this.datosInscripcion.expoData.expo_dog_classes;
      //retornamos el contador de la clase 10 que es la de grupo de cria
      return tmp.filter(c => c.dog_class_id === 10).length;
    },
    /* MOSTRAR PAREJAS */
    compExisteInsParejas() {
      const tmp = this.datosInscripcion.expoData.expo_dog_classes;
      //retornamos el contador de la clase 10 que es la de grupo de cria
      return tmp.filter(c => c.dog_class_id === 9).length;
    },
    /* para comprobar el numero de perros inscritos */
    compCalcularPerrosInscritos() {
      const inscrip = this.datosInscripcion.inscripciones;
      if (inscrip === null) {
        return 0;
      }
      let contador = 0;
      inscrip.forEach(ele => {
        // console.log(ele, inscrip);
        contador += ele.dogs.length;
      });

      return contador;
    },
    /* FUNCION PARA VER LOS DATOS NORMALIZADOS DE LA INSCRIPCION (TABLA) */
    datosNormalizados() {
      let tarifaNormalizada = [];
      //console.log(this.datosInscripcion);

      if (this.datosInscripcion.inscripciones === null) {
        return tarifaNormalizada;
      }

      const dogTarifas = this.datosInscripcion.inscripciones;

      for (let i = 0; i < dogTarifas.length; i++) {
        const element = dogTarifas[i];
        const tarifaId = element.tarifaId;

        element.dogs.forEach(e => {
          //recogemos los datos del perro
          const currDog = this.datosInscripcion.userData.dogs.find(
            d => d.id === e.id
          );

          const precioTotal =
            this.socio === 1 ? e.precio.price_partner : e.precio.price;
          let row = {
            expoId: this.datosInscripcion.expoId,
            dogId: e.id,
            tarifaId: tarifaId,
            clase: e.clase,
            precio: precioTotal,
            filtrosAplicados: e.filtrosAplicados,
            descuentos: calcularDescuentos(
              e.descuentos,
              this.datosInscripcion.socio,
              precioTotal
            ),
            grupoPrecio: e.grupoPrecio,
            posicion: e.posicion,
            precioAplicado: e.precioAplicado,
            hayCopropietarios: e.hayCopropietarios,
            socio: this.datosInscripcion.socio,
            sexo: currDog.sex_id //1 para macho 2 hembra
          };
          //  console.log(row);
          tarifaNormalizada.push(row);
        });
      }
      return tarifaNormalizada;
    }
  },
  watch: {
    /* COMPROBAR SI SE PULSA EL BOTON RESETEAR LA INSCRIPCION */
    getUserDefaultData: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        console.log("detectado cambios");
        if (newValue.resetData === true) {
          this.icClass = null;
          this.datosInscripcion = {
            aceptadasCondiciones: 0, //aceptacion de las condiciones
            expoId: null, //id de la expo seleccionada
            expoData: null, //datos de la exposición una vez elegida
            gruposCria: null,
            inscripciones: null,
            otrosConceptos: [],
            parejas: null,
            socio: 0,
            socioNumero: null,
            userData: null,
            datosParejas: null,
            datosGrupoCria: null
          };
          this.datosInscripcion = this.getUserDefaultData.datosInscripcion;
          this.resetCurrentIns(false);
          this.currentTab = -1;
          this.getUserInscripcionData().then(() => {
            this.datosInscripcion.userData = this.userInsData.data;
            this.getUserOpenExpos().then(() => {
              //Si hemos recuperado los datos de las expos abiertas
              if (this.currentOpenExpos.data.length > 0) {
                this.currentTab = 0;
               // this.showTab(this.currentTab);
              }
            });
          });
        }
      }
    }
  },
  mounted() {
    //recogemos los datos del usuario para las inscripciones
    this.getUserInscripcionData().then(() => {
      this.datosInscripcion.userData = this.userInsData.data;
      this.getUserOpenExpos().then(() => {
        //Si hemos recuperado los datos de las expos abiertas
        if (this.currentOpenExpos.data.length > 0) {
          this.currentTab = 0;
          //this.showTab(this.currentTab);
        }
      });
    });
  }
};

/* funcion para calcular importes de la tarifa en la normalizacion de datos */
const calcularDescuentos = (objDiscount, socio, precioAplicado) => {
  let total = precioAplicado;
  let salida = 0;
  //console.log(objDiscount, socio, precioAplicado);
  objDiscount.forEach(x => {
    //importe
    if (x.tipo === 1) {
      total -= x.descuento;
      salida -= x.descuento;
    } else {
      //es un %
      total = (100 * x.descuento) / precioAplicado;
      salida += (100 * x.descuento) / precioAplicado;
    }
  });
  //const salida = total < 0 ? 0 : total;
  return salida * -1;
};
</script>
<style scoped>
>>>select {
  height: 35px !important;
  padding: 5px 10px 5px 10px;
}
</style>
